<template>
  <div
    class="kvass-read-more"
    :class="{
      'kvass-read-more--expanded': expanded,
      'kvass-read-more--active': active,
      [`kvass-read-more--placement-${placement}`]: true,
    }"
    :style="{ '--limit': expanded ? 1e6 : limit }"
    @click="onClick"
    :data-label="expanded ? labels.less : labels.more"
  >
    <slot><span v-html="value"></span></slot>
  </div>
</template>

<script>
export default {
  props: {
    labels: {
      type: Object,
      default: function () {
        return { more: this.$t('readMore'), less: this.$t('showLess') }
      },
    },
    placement: {
      default: 'left',
      enums: ['left', 'center', 'right'],
    },
    value: String,
    limit: {
      type: Number,
      default: 3,
    },
  },
  watch: {
    value: 'init',
  },
  data() {
    return {
      expanded: false,
      active: false,
    }
  },
  methods: {
    init() {
      this.active = this.$el.scrollHeight - 1 > this.$el.clientHeight
    },
    onClick() {
      if (!this.active) return
      this.expanded = !this.expanded
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="scss">
.kvass-read-more {
  $space: 2.5em;

  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: var(--limit);
  -webkit-box-orient: vertical;
  position: relative;
  padding-bottom: $space !important;

  &--placement {
    &-center {
      &::after {
        text-align: center;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    &-right {
      &::after {
        right: 0;
      }
    }
  }

  &--active:after {
    content: attr(data-label);
    display: block;
    position: absolute;
    cursor: pointer;
    bottom: 0.6em;
    background: inherit;
    background-color: inherit;
    transition: transform 100ms ease, opacity 100ms ease;
  }

  &--active:before {
    content: '';
    display: block;

    width: 100%;
    height: $space;
    bottom: 0;
    position: absolute;
    background: inherit;
    background-color: inherit;
  }
}
</style>
